export enum EAppStep {
    EDITION = 'edition',
    PREVIEW = 'preview',
    TEMPLATES = 'templates',
}
